// Custom Error Types

export class MaxRetriesError extends Error {
  constructor(message: string) {
      super(message);
      this.name = "MaxRetriesError";
  }
}

// Raised when the refresh token itself was refused, so no retry can succeed
// and the user is on their way to the login page.
export class SessionExpiredError extends Error {
  constructor(message: string = "Session expired") {
    super(message);
    this.name = "SessionExpiredError";
  }
}
